import Index from 'fastboot-admin/src/views/common/Index.vue'

export default [
    {
        path: '/',
        name: 'index',
        meta: {tab: false},
        component: Index,
        children:[
            {
                path: '/dev-cat/list',
                name: 'dev-cat-list',
                meta: {title: '组织架构', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dev-cat/List'),
            },
            {
                path: '/dev-cat/add',
                name: 'dev-cat-add',
                meta: {title: '新增组织', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dev-cat/Add'),
            },
            {
                path: '/dev-cat/edit',
                name: 'dev-cat-edit',
                meta: {title: '编辑组织', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dev-cat/Edit'),
            },
            {
                path: '/device/list',
                name: 'device-list',
                meta: {title: '设备列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/device/List'),
            },
            {
                path: '/device/add',
                name: 'device-add',
                meta: {title: '新增设备', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/device/Add'),
            },
            {
                path: '/device/edit',
                name: 'device-edit',
                meta: {title: '编辑设备', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/device/Edit'),
            },
            {
                path: '/wxp-user/list',
                name: 'wxp-user-list',
                meta: {title: '用户列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/wxp-user/List'),
            },
            {
                path: '/wxp-user/approve-list',
                name: 'wxp-approve-list',
                meta: {title: '用户审核列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/wxp-user/ApproveList'),
            },
            {
                path: '/wxp-user/add',
                name: 'wxp-user-add',
                meta: {title: '新建用户档案', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/wxp-user/Add'),
            },
            {
                path: '/wxp-user/edit',
                name: 'wxp-user-edit',
                meta: {title: '编辑用户档案', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/wxp-user/Edit'),
            },
            {
                path: '/dev-msg/list',
                name: 'dev-msg-list',
                meta: {title: '设备消息', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dev-msg/List'),
            }
        ]
    }
]
;
